import { ApplicationCodes } from "Api/Api";
import * as React from "react";
import {
  AccessRoleIcon,
  BeTestedIcon,
  BlogicGameIcon,
  CommitGuruIcon,
  CompaniesIcon,
  DashboardIcon,
  DutyFreeIcon,
  FakturoidIcon,
  GoogleDriveIcon,
  HumanResourcesIcon,
  MarketplaceIcon,
  ProjectsIcon,
  SettingsIcon,
  VacationIcon,
  JiraIcon,
  HelpdeskITIcon,
  LunchBuddyIcon,
  RovoChatIcon,
} from "Components/Shared/Icons";
import { ConfluenceIcon } from "Components/Shared/Icons/ConfluenceIcon";
import { BlogicAIChatIcon } from "Components/Shared/Icons/BlogicAIChatIcon";

export const useApplicationIcon = () => {
  return (appCode: ApplicationCodes) => {
    switch (appCode) {
      case ApplicationCodes.HumanResourcesEmployees:
        return <HumanResourcesIcon />;

      case ApplicationCodes.ManagementUsers:
        return <SettingsIcon />;

      case ApplicationCodes.ManagementCompanies:
        return <CompaniesIcon />;

      case ApplicationCodes.ManagementAccessRoles:
        return <AccessRoleIcon />;

      case ApplicationCodes.OperationalDutyFree:
        return <DutyFreeIcon />;

      case ApplicationCodes.Dashboard:
        return <DashboardIcon />;

      case ApplicationCodes.FakturoidApp:
        return <FakturoidIcon />;

      case ApplicationCodes.BlogicGame:
        return <BlogicGameIcon />;

      case ApplicationCodes.CommitGuru:
        return <CommitGuruIcon />;

      case ApplicationCodes.GoogleRoot:
        return <GoogleDriveIcon />;

      case ApplicationCodes.Confluence:
        return <ConfluenceIcon />;
      case ApplicationCodes.Marketplace:
        return <MarketplaceIcon />;

      case ApplicationCodes.Projekty:
        return <ProjectsIcon />;

      case ApplicationCodes.Dovolena:
        return <VacationIcon />;

      case ApplicationCodes.BeTested:
        return <BeTestedIcon />;

      case ApplicationCodes.Jira:
        return <JiraIcon />;

      case ApplicationCodes.HelpdeskIT:
        return <HelpdeskITIcon />;

      case ApplicationCodes.BlogicAIChat: {
        return <BlogicAIChatIcon />;
      }

      case ApplicationCodes.LunchBuddy:
        return <LunchBuddyIcon />;

      case ApplicationCodes.RovoChat:
        return <RovoChatIcon />;
    }
  };
};
